// ---- Meta Pixel ----
const fbInitializedIds = new Set()

export function loadFBPixel(pixelId) {
  if (typeof window === 'undefined') return

  // If fbq already exists, just ensure this pixelId is initialized once.
  if (window.fbq) {
    if (!fbInitializedIds.has(pixelId)) {
      window.fbq('init', pixelId)
      fbInitializedIds.add(pixelId)
    }
    return
  }

  // Create stub and inject the script once
  ;(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  if (!fbInitializedIds.has(pixelId)) {
    window.fbq('init', pixelId)
    fbInitializedIds.add(pixelId)
  }
}

// ---- GA4 ----
export function loadGA4(ga4Tag) {
  if (typeof window === 'undefined') return
  if (window.gtag) return // Already loaded

  const script = document.createElement('script')
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Tag}`
  script.async = true
  document.head.appendChild(script)

  script.onload = () => {
    window.dataLayer = window.dataLayer || []
    function gtag() {
      window.dataLayer.push(arguments)
    }
    window.gtag = gtag

    gtag('js', new Date())
    gtag('config', ga4Tag, { anonymize_ip: true })
  }
}

// ---- SPA pageview for both ----
export function trackPageView(url) {
  if (typeof window === 'undefined') return
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: url || window.location.pathname + window.location.search,
    })
  }
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}
